import Logo from 'images/extra-svg/LogoRelease.svg'
import LogoChristmas from 'images/extra-svg/LogoChristmas.svg'

const isHolidayOffer = () => {
  // only used for the Logo change for 2022 holiday season. Change to false to revert to the normal logo
  return false
}
export const LogoOfTheDay = isHolidayOffer() ? LogoChristmas : Logo
